export const Feature = Object.freeze({
    onboarding: 'onboarding',
    sharing: 'sharing',
    settings: 'settings',
});